module.exports = __webpack_public_path__ + "img/mic.9e947d0b.svg";